import { render, staticRenderFns } from "./VerificacionStock.vue?vue&type=template&id=61696ef1&scoped=true"
import script from "./VerificacionStock.vue?vue&type=script&lang=js"
export * from "./VerificacionStock.vue?vue&type=script&lang=js"
import style0 from "./VerificacionStock.vue?vue&type=style&index=0&id=61696ef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61696ef1",
  null
  
)

export default component.exports